// Status badges for a topic (live / candidate / pending versions) and for a
// single version.

import type { TalkTrackTopic, VersionStatus } from "../../types/talkTrack";
import { statusLabel } from "./format";

export function VersionBadge({ status }: { status: VersionStatus }) {
  return <span className={`badge badge-${status}`}>{statusLabel(status)}</span>;
}

export function TopicBadges({
  topic,
  draft,
  inReview,
  approved,
}: {
  topic: TalkTrackTopic;
  draft?: number | null;
  inReview?: number | null;
  approved?: number | null;
}) {
  return (
    <span className="tt-badges">
      {!topic.enabled && <span className="badge badge-disabled">disabled</span>}
      {topic.liveVersion !== null ? (
        <span className="badge badge-published">live v{topic.liveVersion}</span>
      ) : (
        <span className="badge">not live</span>
      )}
      {topic.candidateVersion !== null && (
        <span className="badge badge-candidate" title="A/B candidate — the rest of users stay on live">
          candidate v{topic.candidateVersion} at {topic.rolloutPct}%
        </span>
      )}
      {approved != null && <span className="badge badge-approved">approved v{approved}</span>}
      {inReview != null && <span className="badge badge-in_review">in review v{inReview}</span>}
      {draft != null && <span className="badge badge-draft">draft v{draft}</span>}
    </span>
  );
}
